import React, {useContext, useEffect, useState} from 'react';
import UseStyle from "../useStyles";
import { Button } from '@material-ui/core';
import { AppContext } from "../../shared/context";
import { convocacaoReuniao } from '../../../services/reuniao/ReuniaoService';
import TipoPerfil from "../../../constants/tipoPerfil";

const ReunioesImageHeader = (props) => {
  const classes = UseStyle();

  const {
    idReuniao,
    edicao,
    periodicidade,
    conselho,
    opcoes = [],
    ativo,
    setAtivo,
    reuniaoPassada,
    history,
    qtdConvidados,
    dataConvocacao
  } = props;

  const periodicidadesMap = { 'ORDINARIA': 'Ordinária', 'EXTRAORDINARIA': 'Extraordinária' };

  const { role, reuniaoUpdate } = useContext(AppContext);

  const { setReuniaoUpdate } = reuniaoUpdate;

  const [mostrarNovaReuniao, setMostarNovaReuniao] = useState(false);

  const [convocacaoEnviada, setConvocacaoEnviada] = useState(false);

  const handleConvocacao = async () => {
    await convocacaoReuniao(idReuniao);
    setConvocacaoEnviada(true);
    setReuniaoUpdate('abaConvidados');
  }

  useEffect(() => {
    setMostarNovaReuniao(TipoPerfil.EQUIPE_TECNICA.is(role));
  }, [])

  const handleClick = (num) => {
    setAtivo(num);
  }



  function calculoDias() {

    if (!dataConvocacao) {
      return true;
    }
    var dataC = new Date(dataConvocacao);
    var hoje = new Date();
    var timeDiff = Math.abs(hoje.getTime() - dataC.getTime());
    var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

    if (diffDays > 7) {
      return true;
    } else {
      return false;
    }

  }

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <div className={reuniaoPassada ? classes.headerImageVerde : classes.headerImage}>
        <div style={{ color: '#fff', position: 'relative', margin: 0, padding: '24px 0 0 24px', display: 'flex', alignItems: 'center', minHeight: 292 }}>
          <div>
            <p className={classes.headerInfo}>{edicao}° REUNIÃO {periodicidadesMap[periodicidade]}</p>
            <p className={classes.headerNome}>{conselho}</p>
          </div>
        </div>
        <div style={{ position: 'relative', bottom: 0, left: 24, display: 'flex', flexWrap: 'wrap' }}>
          {opcoes.map((item, key) => (
            <div onClick={() => handleClick(key)} className={ativo === key ? classes.headerFooterButtonActive : classes.headerFooterButton}>{item}</div>
          ))}
        </div>
        <div style={{ position: 'absolute', top: 24, right: 24 }}>
          {mostrarNovaReuniao &&
            <>
              <Button onClick={() => history.push(`/reuniao/${idReuniao}/editar`)} variant="outlined">Editar Reunião</Button>
              {calculoDias() && qtdConvidados > 0 && !reuniaoPassada && !convocacaoEnviada && <Button onClick={() => handleConvocacao()} variant="outlined">Enviar Convocação</Button>}
            </>
          }
          {/* {aba === 4 && <Button style={{ marginLeft: 10 }} variant="contained"> Enviar convocação</Button>} */}
        </div>
      </div>
    </div>
  );
}

export default ReunioesImageHeader;
